/**
 * Formats a number to a string with specified decimal places.
 * Uses the German locale for formatting.
 * @param {number} value - Number to be formatted.
 * @param {number} [minimumFractionDigits=0] - Minimun number of decimal places.
 * @param {number} [maximumFractionDigits=2] - Maximum number of decimal places.
 * @returns {string} - Returns the formatted number as a string.
 */
export const formatNumber = (value, minimumFractionDigits = 1, maximumFractionDigits = 1) => {
    return new Intl.NumberFormat("de-DE", {
      style: "decimal",
      minimumFractionDigits,
      maximumFractionDigits,
    }).format(value);
  };
 

  /**
 * Scales a number and returns it either as a number or a formatted string.
 * @param {number} value - The number to be scaled.
 * @param {number} divisor - The value by which the number is divided (e.g., 1000).
 * @returns {number | string} - The scaled number as a number or string.
 */
export const scaleNumber = (value, divisor = 1) => {
  const scaledValue = value / divisor;
  return scaledValue;
};

/**
 * Utility function to extract a value from raw data by key.
 * @param {Array} rawData - The raw data array.
 * @param {string} key - The key to search for in the raw data.
 * @returns {number | Array} - The value associated with the key, or 0 if not found.
 */
export const getValueFromRawData = (rawData, key) => {
  return rawData.find((item) => item.name === key)?.value || 0;
};